import React, { useState } from "react";
import searchIcon from '../../assets/images/search_icon.png';
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { COURSES_QUERY, CURRENT_USER_QUERY } from "../../queries/queries";

const CourseFind = ({ text }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const history = useHistory();

  const { loading, error, data } = useQuery(COURSES_QUERY, {
    fetchPolicy: "no-cache",
  });

  const user = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: "no-cache",
  });
  const currentUserName = user?.data?.currentUser?.firstName || ''

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const normalize = (s) =>
    (s ?? "")
      .toString()
      .toLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, ""); 

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && data?.allCourses) {
      const q = normalize(searchQuery);

      const filteredCourses = data.allCourses.filter((course) => {
        const name = normalize(course.name);
        const nameShort = normalize(course.nameShort);
        const brand = normalize(course.brand);
        return (
          name.includes(q) ||
          nameShort.includes(q) ||
          brand.includes(q)
        );
      });

      history.push({
        pathname: "/courses-result",
        state: { courses: filteredCourses },
      });
    }
  };


  return (
    <div>
      <div className="course-find-welcome-text">{text}</div>
      <div className="course-find-search">
        <input 
          className="course-find-search-input"
          placeholder="Finde jetzt deinen Kurs"
          onChange={handleSearchChange}
          value={searchQuery}
          onKeyDown={handleKeyPress}
        ></input>
        <div className="course-find-search-icon"><img src={searchIcon}></img></div>
      </div>
    </div>
  );
};
  
export default CourseFind;
  